import { startTestTrack } from '../features/test-track/testTrack';

export const testTrackPromise = startTestTrack();
